module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h5>' +
__e( fontFamily ) +
'</h5><label>Format: ' +
__e( extension ) +
'</label>\n<span class="delete-icon';
 if (readOnly) { ;
__p += ' disabled';
};
__p += '"></span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/fonts/CustomFontItemView.tpl
// module id = 3128
// module chunks = 0